export default __webpack_public_path__ + "static/media/icn-loans.608956ed.svg";